'use client';

import { Typography } from '@gds/Typography/Typography';
import { useModal } from '@modal/Hooks/UseModal';
import { ReserveNowBadge } from '@shared-components/ReserveNowBadge/ReserveNowBadge';
import { ReserveNowHowItWorks } from '@shared-components/ReserveNowHowItWorks/ReserveNowHowItWorks';

import type { ReservationFaqContent } from '../../Entities/FaqContent.entity';
import { ReserveNowFaq } from './ReserveNowFaq/ReserveNowFaq';

import styles from './ReserveNowCard.module.css';

interface ReserveNowCardProps {
  title?: string;
  hasBadge?: boolean;
  hasBottomLink?: boolean;
  strings: Record<string, any>;
  faqContent: ReservationFaqContent;
}

export const ReserveNowCard = ({
  title,
  hasBadge = true,
  hasBottomLink = true,
  strings,
  faqContent,
}: ReserveNowCardProps) => {
  const { openModal } = useModal();
  const handleFindOutMoreClick = () => {
    openModal(<ReserveNowFaq faqContent={faqContent} title={strings.reserveNowTitle} />, {
      header: true,
      modalClassName: styles.modalContainer,
      modalBodyClassName: styles.modalBody,
    });
  };

  return (
    <div className={styles.reserveVehicleCardWrapper}>
      <div className={styles.headerWrapper}>
        <div className={`${styles.titleWrapper} ${!hasBadge && styles.fullWidth}`}>
          <Typography variant="subheading1">{title ? title : strings.reserveNowTitle}</Typography>
        </div>
        {hasBadge && <ReserveNowBadge desktopString={strings.newFeature} />}
      </div>
      <ReserveNowHowItWorks strings={strings} />
      {hasBottomLink && (
        <div className={styles.footerWrapper}>
          <Typography variant="buttonLink2" onClick={handleFindOutMoreClick}>
            {strings.findOutMore}
          </Typography>
        </div>
      )}
    </div>
  );
};
